import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Image,
  InputGroup,
  InputRightElement,
  Text,
  useDisclosure,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper,
  StepSeparator,
  StepStatus,
  StepTitle,
  Table,
  TableContainer,
  Tbody,
  Td,
  Thead,
  Tr,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  // useDisclosure,
} from "@chakra-ui/react";
import TableLocking from "./tableLocking";
import IconFile from "../../assets/images/booking/upfile.svg";
import iconPlus from "../../assets/images/booking/plus.svg";
import iconPlus2 from "../../assets/images/personnelCategories/plus.svg";
import PopupImport from "../../components/popup/PopupImport";
// import FormDetail from "./form/detail";
import { commonCall } from "../../api/common";
import toast from "react-hot-toast";
import { lockingCall } from "../../api/locking";
import { lockingImageCall } from "../../api/lockingImage";
import { lockingParticipantCall } from "../../api/lockingParticipant";
import { exportFile, formatDateDb } from "../../utils/tools";
import { formatDateToLocal, formatPriceUS } from "../../utils/utils";
import { useLocking } from "../../hooks/useLooking";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { lockingRelativeParticipantCall } from "../../api/lockingRelativeParticipant";
import { formatTableValue } from "./formatTable";
import iconApproved from "../../assets/images/receiveSalary/check-circle.svg";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import {
  InputControl,
  SelectControl,
} from "../../components/form/formControls";
import { useCategories } from "../../categorys/calculateServiceFees/detail";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import DatePicker from "react-datepicker";
import { commissionCall } from "../../api/commission";
import { attendanceCall } from "../../api/attendance";
import Decimal from "decimal.js";

// ─── Decimal helpers ───────────────────────────────────────────────────────
const _D = (v) => {
  try {
    const d = new Decimal(v ?? 0);
    return d.isFinite() ? d : new Decimal(0);
  } catch {
    return new Decimal(0);
  }
};
const _safeDivD = (a, b, fallback = 0) => {
  const db = _D(b);
  return db.isZero() ? new Decimal(fallback) : _D(a).div(db);
};
// ──────────────────────────────────────────────────────────────────────────

const schemaEdit = Yup.object().shape({
  employeeId: Yup.string().required("Nhân viên tham gia là bắt buộc"),
  relativeId: Yup.string().optional(),
  commissionRate: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .required("Ngày công là bắt buộc"),
  workingDays: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .required("Ngày công là bắt buộc"),
  incomePrice: Yup.string(),
  platformIncomePrice: Yup.string(),
  salesCommissionPrice: Yup.string(),
  eliteSalesCommissionPrice: Yup.string(),
});

export default memo(function StepEmployeeForm({
  lockingId,
  locking,
  item,
  index,
  onChangeRow,
  title,
  setStepHandle,
}) {
  const {
    register,
    setValue,
    handleSubmit,
    watch,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schemaEdit),
    defaultValues:
      {
        ...item,
      } || {},
  });

  const [zIndex, setZIndex] = useState("");
  const [focusStates, setFocusStates] = useState({});
  const handleFocus = (field, data) => {
    if (data) {
      setZIndex(data);
    }
    setFocusStates((prev) => ({ ...prev, [field]: true }));
  };
  const handleBlur = (field, data) => {
    setZIndex("");
    setFocusStates((prev) => ({ ...prev, [field]: false }));
  };
  const [incomePrice, setIncomePrice] = useState(0);
  const [platformIncomePrice, setPlatformIncomePrice] = useState(0);
  const [salesCommissionPrice, setSalesCommissionPrice] = useState(0);
  const [eliteSalesCommissionPrice, setEliteSalesCommissionPrice] = useState(0);

  const [shouldFetch, setShouldFetch] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const { constantData } = useCategories(
    watch("employeeId") || item?.employeeId,
    shouldFetch,
    item?.isCollaborator,
    item?.relativeId,
  );

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({
      value: key,
      label: value,
    }));

  const employeeDatas = useMemo(
    () => formatEntries(constantData?.employeeData),
    [constantData?.employeeData],
  );

  const getAttendance = async (employeeId, locking) => {
    const date = locking?.transactionDate
      ? new Date(locking.transactionDate)
      : new Date();
    const month = date.getMonth() + 1; // Lấy tháng từ 1 đến 12
    const year = date.getFullYear();

    const attendance = await attendanceCall.getByEmployee(
      employeeId,
      month,
      year,
    );

    const { isCollaborator, workingDays = 0 } = item;
    const newWorkingDays = isCollaborator
      ? workingDays
      : attendance?.workingDays || 0;
    const amountHeld = attendance?.brokerDebtCertificate?.amountHeld || 0;

    onChangeRow(index, {
      workingDays: Number(newWorkingDays),
      amountHeld: Number(amountHeld),
      // Cờ Elite lấy trực tiếp từ chấm công, dùng để quyết định công thức elite
      isElite: attendance?.isElite === true,
    });
  };

  const onchangeEmpoyeeList = (option) => {
    // setValue("employeeId", option);
    onChangeRow(index, { employeeId: option });
    if (option && locking) {
      getAttendance(option, locking);
    }
  };

  //   const relativeDatas = useMemo(
  //     () => formatEntries(constantData?.relativeData),
  //     [constantData?.relativeData]
  //   );

  //   const onchangeRelativeList = (option) => {
  //     setValue("relativeId", option);
  //   };

  const onChangeIncomePrice = useCallback((event) => {
    const { value } = event.target;
    const numericValue = value.replace(/[^0-9]/g, "");
    setIncomePrice(formatPriceUS(numericValue));
    onChangeRow(index, { incomePrice: Number(numericValue) });
  }, []);

  const onChangePlatformIncomePrice = useCallback((event) => {
    const { value } = event.target;
    const numericValue = value.replace(/[^0-9]/g, "");
    setPlatformIncomePrice(formatPriceUS(numericValue));
    onChangeRow(index, { platformIncomePrice: Number(numericValue) });
  }, []);

  const onChangeSalesCommissionPrice = useCallback((event) => {
    const { value } = event.target;
    const numericValue = value.replace(/[^0-9]/g, "");
    setSalesCommissionPrice(formatPriceUS(numericValue));
    //   setValue("salesCommissionPrice", Number(numericValue), {
    //     shouldValidate: true,
    //   });
    onChangeRow(index, { salesCommissionPrice: Number(numericValue) });
  }, []);

  const onChangeEliteSalesCommissionPrice = useCallback((event) => {
    const { value } = event.target;
    const numericValue = value.replace(/[^0-9]/g, "");
    setEliteSalesCommissionPrice(formatPriceUS(numericValue));
    //   setValue("eliteSalesCommissionPrice", Number(numericValue), {
    //     shouldValidate: true,
    //   });
    onChangeRow(index, { eliteSalesCommissionPrice: Number(numericValue) });
  }, []);

  const businessCategoryCodeFormat = (workingDays = 0) => {
    if (Number(workingDays) < 15) {
      return "CVKD";
    } else if (Number(workingDays) >= 15) {
      return "CVKD Elite";
    } else return "-";
  };

  useEffect(() => {
    if (!item) return;

    const {
      calculateCommissionRate = 0,
      transactionRate = 0,
      incomeRate = 0,
      platformIncomeRate = 0,
      salesCommissionRate = 0,
      eliteSalesCommissionRate = 0,
      kRate = 0,
      commissionRate = 0,
      priceForCommission = 0,
      priceTNSan = 0,
      businessCategoryCode,
      workingDays = 0,
      standardWorkingDaysInMonth = 0,
      amountHeld = 0,
      isElite = false,
    } = item;

    // ── Decimal: tính giá NV tham gia ─────────────────────────────────────
    const _cRate = _D(commissionRate).div(100);

    const incomePrice = _D(calculateCommissionRate)
      .div(100)
      .mul(_D(transactionRate).div(100))
      .mul(_D(incomeRate).div(100))
      .mul(_cRate)
      .mul(_D(priceForCommission))
      .toNumber();

    const platformIncomePrice = _D(calculateCommissionRate)
      .div(100)
      .mul(_D(transactionRate).div(100))
      .mul(_D(platformIncomeRate).div(100))
      .mul(_cRate)
      .mul(_D(priceForCommission))
      .plus(_D(priceTNSan).mul(_cRate))
      .toNumber();

    const salesCommissionPrice = _D(kRate)
      .mul(_D(calculateCommissionRate).div(100))
      .mul(_D(transactionRate).div(100))
      .mul(_D(salesCommissionRate).div(100))
      .mul(_cRate)
      .mul(_D(priceForCommission))
      .toNumber();

    // Dòng được coi là Elite khi: cờ isElite = true (đồng bộ từ chấm công)
    // HOẶC dòng vốn đã có Số tiền PDV CVKD Elite > 0 (đã được tính Elite trước đó,
    // đúng như lúc mới vào trang). Nhờ vậy khi sửa ngày công/số khác, Elite được
    // tính lại theo công thức cũ (scale theo ngày công) thay vì bị ghi về 0.
    const isEliteRow =
      isElite === true || Number(item?.eliteSalesCommissionPrice || 0) > 0;

    const eliteSalesCommissionPrice = isEliteRow
      ? _D(kRate)
          .mul(_D(calculateCommissionRate).div(100))
          .mul(_D(transactionRate).div(100))
          .mul(_D(eliteSalesCommissionRate).div(100))
          .mul(_cRate)
          .mul(_safeDivD(_D(workingDays), standardWorkingDaysInMonth))
          .mul(_D(priceForCommission))
          .toNumber()
      : 0;
    // ────────────────────────────────────────────────────────────────────────

    setIncomePrice(formatPriceUS(incomePrice));
    setPlatformIncomePrice(formatPriceUS(platformIncomePrice));
    setSalesCommissionPrice(formatPriceUS(salesCommissionPrice));
    setEliteSalesCommissionPrice(formatPriceUS(eliteSalesCommissionPrice));

    onChangeRow(index, {
      incomePrice: Number(incomePrice),
      platformIncomePrice: Number(platformIncomePrice),
      salesCommissionPrice: Number(salesCommissionPrice),
      eliteSalesCommissionPrice: Number(eliteSalesCommissionPrice),
    });
  }, [item?.commissionRate, item?.workingDays, item?.isElite]);

  useEffect(() => {
    if (!item) return;

    const raw = {
      incomePrice: Number(item?.incomePrice || 0),
      platformIncomePrice: Number(item?.platformIncomePrice || 0),
      salesCommissionPrice: Number(item?.salesCommissionPrice || 0),
      eliteSalesCommissionPrice: Number(item?.eliteSalesCommissionPrice || 0),
    };

    setIncomePrice((prev) => {
      const newVal = formatPriceUS(raw.incomePrice);
      return prev !== newVal ? newVal : prev;
    });

    setPlatformIncomePrice((prev) => {
      const newVal = formatPriceUS(raw.platformIncomePrice);
      return prev !== newVal ? newVal : prev;
    });

    setSalesCommissionPrice((prev) => {
      const newVal = formatPriceUS(raw.salesCommissionPrice);
      return prev !== newVal ? newVal : prev;
    });

    setEliteSalesCommissionPrice((prev) => {
      const newVal = formatPriceUS(raw.eliteSalesCommissionPrice);
      return prev !== newVal ? newVal : prev;
    });

    onChangeRow(index, raw);
  }, [
    item?.incomePrice,
    item?.platformIncomePrice,
    item?.salesCommissionPrice,
    item?.eliteSalesCommissionPrice,
  ]);

  return (
    <Box w={"100%"}>
      <Text
        color={"var(--color-header-employee)"}
        fontSize={"14px"}
        fontWeight={"600"}
      >
        {title ? title : !item?.isCollaborator ? "Người bán chính" : "CTV"}{" "}
        {`(${businessCategoryCodeFormat(item?.workingDays)})`}
      </Text>
      {/* 3 */}
      <Flex
        justifyContent={"space-between"}
        alignItems={"flex-start"}
        gap={"27px"}
        mb={"12px"}
        w={"100%"}
      ></Flex>
      {/* 4 */}

      {/* 5 */}
      <Flex
        justifyContent={"space-between"}
        alignItems={"flex-start"}
        gap={"27px"}
        mb={"12px"}
        w={"100%"}
      >
        <Box flex={1}>
          <SelectControl
            label={"Nhân viên tham gia"}
            dataOption={employeeDatas}
            placeholder="Chọn nhân viên tham gia"
            selectedMain={watch("employeeId")}
            onChange={onchangeEmpoyeeList}
            onFocus={() => handleFocus("employeeId")}
            onBlur={() => handleBlur("employeeId")}
            state={focusStates["employeeId"]}
            registerProps={register("employeeId")}
            errorMessage={errors.employeeId}
            mwidth="100%"
            isSearchable={true}
            isRequired={true}
          />
        </Box>

        <Box flex={1}>
          <InputControl
            type="number"
            label="Tỉ lệ (%)"
            placeholder="Nhập tỉ lệ"
            errors={errors.commissionRate}
            register={register("commissionRate")}
            onFocus={() => handleFocus("commissionRate")}
            onBlur={() => handleBlur("commissionRate")}
            state={focusStates["commissionRate"]}
            mwidth={"100%"}
            onlyPositiveNumbers={true}
            value={item.commissionRate}
            onChange={(e) =>
              onChangeRow(index, { commissionRate: Number(e.target.value) })
            }
            onChangeData={() => setStepHandle(1)}
          />
          <Text
            mt={"6px"}
            color={"var(--color-secondary)"}
            fontSize={"14px"}
            fontWeight={400}
            minW={"140px"}
          >
            (Cho phép chỉnh sửa)
          </Text>
        </Box>

        <Box flex={1}>
          <InputControl
            type="number"
            label="Ngày công "
            placeholder="Nhập Ngày công VD: 23.5"
            errors={errors.workingDays}
            register={register("workingDays")}
            onFocus={() => handleFocus("workingDays")}
            onBlur={() => handleBlur("workingDays")}
            state={focusStates["workingDays"]}
            mwidth={"100%"}
            onlyPositiveNumbers={true}
            value={item.workingDays}
            onChange={(e) => {
              onChangeRow(index, { workingDays: Number(e.target.value) });
            }}
            onChangeData={() => setStepHandle(1)}
          />
          <Text
            mt={"6px"}
            color={"var(--color-secondary)"}
            fontSize={"14px"}
            fontWeight={400}
            minW={"140px"}
          >
            (Cho phép chỉnh sửa)
          </Text>
        </Box>
      </Flex>

      {/* 5 */}
      <Flex
        justifyContent={"space-between"}
        alignItems={"flex-start"}
        gap={"27px"}
        mb={"12px"}
        w={"100%"}
      >
        <Box flex={1}>
          <InputControl
            // type="number"
            label="Số tiền TN MSH (Đi kèm K)"
            placeholder="Số tiền TN MSH"
            errors={errors.incomePrice}
            register={register("incomePrice")}
            onFocus={() => handleFocus("incomePrice")}
            onBlur={() => handleBlur("incomePrice")}
            onChange={onChangeIncomePrice}
            value={incomePrice}
            state={focusStates["incomePrice"]}
            mwidth={"100%"}
            isLockInput={true}
            readOnly={true}
          />
        </Box>

        <Box flex={1}>
          <InputControl
            // type="number"
            label="Số tiền TN sàn"
            placeholder="Số tiền TN sàn"
            errors={errors.platformIncomePrice}
            register={register("platformIncomePrice")}
            onFocus={() => handleFocus("platformIncomePrice")}
            onBlur={() => handleBlur("platformIncomePrice")}
            onChange={onChangeIncomePrice}
            value={platformIncomePrice}
            state={focusStates["platformIncomePrice"]}
            mwidth={"100%"}
            isLockInput={true}
            readOnly={true}
          />
        </Box>

        <Box flex={1}>
          <InputControl
            // type="number"
            label="Số tiền PDV CVKD"
            placeholder="Số tiền PDV CVKD"
            errors={errors.salesCommissionPrice}
            register={register("salesCommissionPrice")}
            onFocus={() => handleFocus("salesCommissionPrice")}
            onBlur={() => handleBlur("salesCommissionPrice")}
            onChange={onChangeSalesCommissionPrice}
            value={salesCommissionPrice}
            state={focusStates["salesCommissionPrice"]}
            mwidth={"100%"}
            isLockInput={true}
            readOnly={true}
          />
        </Box>

        <Box flex={1}>
          <InputControl
            // type="number"
            label="Số tiền PDV CVKD Elite"
            placeholder="Số tiền PDV CVKD Elite"
            errors={errors.eliteSalesCommissionPrice}
            register={register("eliteSalesCommissionPrice")}
            onFocus={() => handleFocus("eliteSalesCommissionPrice")}
            onBlur={() => handleBlur("eliteSalesCommissionPrice")}
            onChange={onChangeEliteSalesCommissionPrice}
            value={eliteSalesCommissionPrice}
            state={focusStates["eliteSalesCommissionPrice"]}
            mwidth={"100%"}
            isLockInput={true}
            readOnly={true}
          />
        </Box>
      </Flex>
    </Box>
  );
});
